import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Observable, map } from 'rxjs';
import { MtSelectorComponent } from '@app/shared/forms/mt-selector/mt-selector.component';
import { DictionariesService } from '@app/core/services/dictionaries.service';
import { IFormInputs } from '@app/interfaces/forms.interface';

@Component({
  selector: 'app-open-banking-selector',
  template: `
    <ng-container *ngIf="inputs$ | async as inputs">
      <lib-mt-selector
        [searchable]="true"
        [fullWidth]="true"
        [formGroup]="form"
        [options]="inputs.Bank"
        [isSubmitted]="isSubmitted"></lib-mt-selector>
    </ng-container>
  `,
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MtSelectorComponent],
})
export class OpenBankingSelectorComponent {
  form: FormGroup = this.fb.group<{ Bank: FormControl<number> }>({
    Bank: this.fb.control(null, Validators.required),
  });
  inputs$: Observable<IFormInputs> = this.dictionariesService.getExthandBanks().pipe(
    map((options) => ({
      Bank: {
        formControlNameValue: 'Bank',
        label: 'SELECT_BANK',
        type: 'dropdown',
        optionLabel: 'Fullname',
        optionValue: 'Connector',
        options,
        validateOnTouched: true,
      },
    }))
  );

  constructor(
    private fb: NonNullableFormBuilder,
    private readonly dictionariesService: DictionariesService
  ) {}

  get isSubmitted() {
    return this.form?.touched || this.form?.dirty;
  }
}
